<template>
    <el-dialog :visible.sync="dialogVisible" title="修改任务模板" custom-class="custom-dialog" :close-on-click-modal="false"
                @opened="dialogOpen" @closed="dialogClose" width="490px" append-to-body >

        <el-form ref="form" :model="form" :rules="rules" label-width="110px">

            <el-form-item  prop="dimensionName" label="类别名称">
                <el-select v-model="form.dimensionName" placeholder="请选择" style="width: 350px;">
                    <el-option
                        v-for="item in dimensionNames"
                        :key="item"
                        :label="item"
                        :value="item">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item  prop="name" label="任务模板名称">
                <el-input v-model="form.name" maxlength="100"  style="width: 350px;"></el-input>
            </el-form-item>

            <el-form-item prop="" label="任务图标">
                <el-upload 
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :auto-upload="true"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="imageUrl" :src="imageUrl" :style="{transform:'rotateZ('+deg+'deg)'}" style="background-color:#d0d0d0;" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>

            <el-form-item  prop="content" label="内容">
                <el-input style="width: 350px;"
                    type="textarea"
                    :rows="6"
                    placeholder="请输入内容"
                    v-model="form.content">
                </el-input>
            </el-form-item>

            <el-form-item  prop="taskType" label="绑定功能">
                <el-select v-model="form.taskType" style="width: 350px;" clearable placeholder="请选择任务类型">
                    <el-option
                        v-for="item in taskTypes"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item   prop="orderNum" label="排序号">
                <el-input v-model="form.orderNum" maxlength="2" type="number"  style="width: 80px;"></el-input>
            </el-form-item>
        
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogClose()">取消</el-button>
            <el-button :loading="loading" type="primary" @click="save()">确定</el-button>
        </span>
    </el-dialog>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        name: 'addTemplateTask',
        components: {},
        props: {
            value: Boolean,
            template: {
                type: Object,
                default() {
                    return {}
                }
            },
            templateTask: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        data(){
            return{
                loading: false,
                dialogVisible: false,
                form:{
                    id: "",
                    dimensionName: "",
                    name: "",
                    content: "",
                    url: "",
                    taskType: "",
                    orderNum: ""
                },
                dimensionNames: [],
                taskTypes:[{
                    value: 3,
                    label: '写实记录'
                }, {
                    value: 4,
                    label: '个人总结'
                }, {
                    value: 5,
                    label: '典型案例'
                }, {
                    value: 6,
                    label: '德育奖惩'
                }],
                rules: {
                    name: [
                        { required: true, message: '请输入任务模板名称', trigger: 'blur' }
                    ],
                    dimensionName: [
                        { required: true, message: '请选择类别名称', trigger: 'blur' }
                    ],
                    orderNum: [
                        { required: true, message: '请输入排序号', trigger: 'blur' }
                    ]
                },
                uploadForm: undefined,
                imageUrl: "",
                uploadUrl:"",
                deg:0
            }
        },
        watch: {
            value(val) {
                this.dialogVisible = val
            },
            dialogVisible(val) {
                this.$emit('input', val)
            },
        },
        created:function () {
        },
        methods:{
            dialogOpen() {
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields()
                }
                // 初始值
                this.form.url = ""
                this.uploadForm = new FormData()
                this.uploadUrl = this.nameUploadImageUrl

                this.form.id= this.templateTask.id
                this.form.dimensionName= this.templateTask.dimensionName
                this.form.name= this.templateTask.name
                this.form.content= this.templateTask.content
                this.imageUrl = this.templateTask.url
                this.form.taskType = this.templateTask.taskType
                this.form.orderNum = this.templateTask.orderNum
                
                this.getDimensionNames()
            },
            dialogClose(){
                this.dialogVisible = false
            },
            // 获取类别名称列表
            getDimensionNames(){
                let url  = this.clockinDimensionCategoryListUrl;
                let data = {
                    deptId: this.template.deptId,
                    name: this.template.dimensionName
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                       this.dimensionNames = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {
                let isJPG = (file.type == 'image/jpeg' || file.type == 'image/png');
                let isLt2M = file.size / 1024 / 1024 < 8;

                if (!isJPG) {
                    this.$message.error('上传商品图片只能是 JPG/PNG 格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传商品图片大小不能超过 8MB!');
                }
                if(isJPG && isLt2M){
                    this.form.url = ""
                    this.imageUrl = ""
                    // 上传文件
                    let uploadForm=new FormData();
                    uploadForm.append('file', file);
                    this.$axios.post(this.nameUploadImageUrl, uploadForm).then((res) => {
                        if(res.data.status == 200){
                        //    console.log("临时文件目录："+res.data.data.localFile);
                           this.form.url=res.data.data.localFile;
                        }else{
                            this.$commonFn.showTip(res.data.message, 3);
                        }
                    }, (err) => {
                        console.log(err)
                        this.$commonFn.showTip("网络繁忙，请稍后重试，响应码("+err.response.status+")", 3);
                    });
                }else{
                    return false;
                }
            },
            // 旋转
            rotate(){
                this.deg += 90;
                if(this.deg >= 360){
                    this.deg = 0
                }
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){

                        if(this.$util.isEmpty(this.imageUrl)){
                            this.$commonFn.showTip('任务图标不可为空',3)
                            return
                        }

                        let url= this.clockinTemplateTaskUpdateUrl
                        let data = {
                            id: this.form.id,
                            dimensionName: this.form.dimensionName,
                            name: this.form.name,
                            content: this.form.content,
                            url: this.form.url,
                            taskType: this.$util.isEmpty(this.form.taskType)?'':this.form.taskType,
                            orderNum: this.form.orderNum
                        };

                        console.log(JSON.stringify(data))
                        // return
                        this.loading = true
                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1)
                                this.dialogVisible=false
                                this.$parent.getData()
                            }else{
                                this.$commonFn.showTip(res.message,3)
                            }
                            this.loading = false
                        }, (err) => {
                            console.log(err)
                            this.loading = false
                        })
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/task/components/updateTemplateTask.vue